import { useState, useEffect } from 'react';
import { API_ENDPOINTS, TIMEOUTS } from '../constants/config';

const useApi = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const makeRequest = async (endpoint, options = {}) => {
    setIsLoading(true);
    setError(null);

    try {
      const url = `${API_ENDPOINTS.baseUrl}${endpoint}`;
      const requestConfig = {
        ...options,
        credentials: 'include', // Include cookies in all requests
        headers: {
          'Content-Type': 'application/json',
          ...options.headers,
        },
      };
      
      // Debug logging for authentication issues (can be removed once issue is resolved)
      // if (endpoint.includes('/vendor/user/') && endpoint.includes('/status')) {
      //   console.log('Making request to:', url);
      //   console.log('Document cookies:', document.cookie);
      // }
      
      const response = await fetch(url, requestConfig);

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (err) {
      setError(err.message || 'Something went wrong');
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  const get = (url, options = {}) => makeRequest(url, { ...options, method: 'GET' });
  const post = (url, body, options = {}) =>
    makeRequest(url, { ...options, method: 'POST', body: JSON.stringify(body) });
  const put = (url, body, options = {}) =>
    makeRequest(url, { ...options, method: 'PUT', body: JSON.stringify(body) });
  const del = (url, options = {}) => makeRequest(url, { ...options, method: 'DELETE' });

  return { isLoading, error, get, post, put, del };
};

export default useApi;
